import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {MatTooltipModule} from '@angular/material/tooltip';
import {DxDataGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule} from 'devextreme-angular';

import {ConfiguracionRoutingModule} from './configuracion-routing.module';
import {ComponentesModule} from '@componentes/Componentes.module';
import {PipesModule} from '@pipes/Pipes.module';

import {EscalaevaluacionComponent} from './escalaevaluacion/escalaevaluacion.component';
import {CompetenciaComponent} from './competencia/competencia.component';
import {CriterioComponent} from './criterio/criterio.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentesModule,
        TranslateModule,
        FormsModule,
        MatTooltipModule,
        DxDataGridModule,
        DxTreeViewModule,
        DxListModule,
        DxContextMenuModule,
        PipesModule,
        ConfiguracionRoutingModule
    ],
    declarations: [
        EscalaevaluacionComponent,
        CompetenciaComponent,
        CriterioComponent
    ],
    entryComponents: [
    ]
})
export class ConfiguracionModule {}
